import React from 'react';
import './assets/css/app.css';
import './assets/css/custom.css';
import { AppRoutes } from './components/AppRouting/AppRoutes';
import 'react-datepicker/dist/react-datepicker.css';

export const App: React.FC = () => {
    return (
        <AppRoutes />
    );
};
